import Authentication from "./authentication";
import SignIn from "./signin";
import Physicals from "./modules/physicals";
import Legals from "./modules/legals";
import States from "./modules/states";
import Cities from "./modules/cities";
import Districts from "./modules/districts";
import Addresses from "./modules/addresses";
import Professionals from "./modules/professionals";
import User from "./modules/user";
import Coupons from "./modules/coupons";
import Orders from "./modules/orders";
import Subscriptions from "./modules/subscriptions";
import Cloudinary from "./modules/cloudinary";
import Payments from "./modules/payments";
import Cycles from "./modules/cycles";
import Feedbacks from "./modules/feedbacks";
import Accounts from "./modules/accounts";
import Dataclips from "./dataclips";
import Freshdesk from "./outers/freshdesk";
import RDStation from "./modules/RDStation";
import AccountTermsOfUse from "./modules/accountTermsOfUse";

export default {
  Authentication,
  SignIn,
  Physicals,
  Legals,
  States,
  Cities,
  Districts,
  Addresses,
  Professionals,
  User,
  Coupons,
  Orders,
  Subscriptions,
  Cloudinary,
  Payments,
  Cycles,
  Feedbacks,
  Accounts,
  Dataclips,
  Freshdesk,
  RDStation,
  AccountTermsOfUse
};



// WEBPACK FOOTER //
// ./src/api/index.js